"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadialProgress = exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Progress = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: 4px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 100px;\n"])), function (props) {
  return (0, _polished.lighten)(.5, props.theme.PrimaryGrey);
});

var Bar = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", "%;\n  background-color: ", ";\n  margin-right: 2px;\n  height: ", ";\n\n  &:first-child {\n      border-top-left-radius: 100px;\n      border-bottom-left-radius: 100px;\n  }\n  \n  &:last-child {\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n  }\n"])), function (props) {
  return props.value;
}, function (props) {
  return props.color;
}, function (props) {
  return props.height;
});

var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/_react["default"].createElement(Progress, props, props.options && props.options ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.options.map(function (elem, index) {
    return /*#__PURE__*/_react["default"].createElement(Bar, {
      height: props.height,
      value: elem.value,
      color: elem.color
    });
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Bar, {
    height: props.height,
    value: props.value,
    color: props.color
  })));
};

exports.ProgressBar = ProgressBar;

var RadialWrapper = _styledComponents["default"].svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transform: rotateZ(-90deg);\n  & circle.chart-line{\n      fill: none;\n      stroke-linecap: round;\n      stroke: ", ";\n      stroke-width: ", ";\n      stroke-dasharray: ", " ", ";\n  }\n  & circle.chart-bk{\n      fill: ", ";\n      stroke: ", ";\n      stroke-width: ", ";\n  }\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.thickness;
}, function (props) {
  return 2 * 22 * props.size / 14 * props.value / 100;
}, function (props) {
  return 2 * 22 * props.size / 14;
}, function (props) {
  return props.innerShade ? props.innerShade : 'none';
}, function (props) {
  return props.outline ? props.outline : 'rgba(0,0,0,0.1)';
}, function (props) {
  return props.thickness;
});

var RadialProgress = function RadialProgress(props) {
  var size = props.size,
      thickness = props.thickness,
      color = props.color;
  return /*#__PURE__*/_react["default"].createElement(RadialWrapper, _extends({}, props, {
    height: "".concat(size + thickness * 2, "px"),
    width: "".concat(size + thickness * 2, "px"),
    viewBox: "0 0 ".concat(size + thickness * 2, " ").concat(size + thickness * 2)
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "chart-bk",
    r: size / 2,
    cx: size / 2 + thickness,
    cy: size / 2 + thickness
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "chart-line",
    r: size / 2,
    cx: size / 2 + thickness,
    cy: size / 2 + thickness
  }));
};

exports.RadialProgress = RadialProgress;
ProgressBar.defaultProps = {
  // nothing to see here
  height: '8px'
};
ProgressBar.propTypes = {
  value: _propTypes["default"].number,
  height: _propTypes["default"].string,
  color: _propTypes["default"].string,
  options: _propTypes["default"].array
};
RadialProgress.defaultProps = {
  outline: 'rgba(0,0,0,0.1)',
  innerShade: 'none'
};
RadialProgress.propTypes = {
  size: _propTypes["default"].number,
  thickness: _propTypes["default"].number,
  color: _propTypes["default"].string,
  innerShade: _propTypes["default"].string,
  outline: _propTypes["default"].string,
  value: _propTypes["default"].number
};